module.exports = __webpack_public_path__ + "static/media/trash.4e0d44f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/trash.svg
// module id = 839
// module chunks = 21